module.exports = __webpack_public_path__ + "img/IMG_5913.6392cd75.jpg";